// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d319efe","455":"806fa07a","977":"9de99c96"}[chunkId] + ".chunk.js";
};